import { useMemo } from 'react';

import HighchartsReact from 'highcharts-react-official';
import { useYearQuarterNavigation } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import getHighchartsInstance from 'utils/charts';
import { getLocalizedMonthNames } from 'utils/date';

import { CapacityResponse } from 'RestAPIs/roster/formation';

import { grossNetViewAtom } from '../atoms';

import { formatCapacityDataForGraph } from '../util';
import { StyledPaper } from 'components/shared/Paper/StyledPaper.styles';

const Highcharts = getHighchartsInstance();

interface CapacityGraphProps {
  capacity?: CapacityResponse;
}

const CapacityGraph = ({ capacity }: CapacityGraphProps) => {
  const { t } = useTranslation('common');

  const { isViewPerWeek } = useYearQuarterNavigation();

  const view = useRecoilValue(grossNetViewAtom);

  const series = useMemo(() => {
    if (capacity) {
      return formatCapacityDataForGraph(capacity, view, t);
    }
    return [];
  }, [capacity, view]);

  const options = {
    title: {
      text: undefined
    },

    chart: {
      type: 'column'
    },

    xAxis: {
      categories: isViewPerWeek
        ? capacity?.grossFormation.periodHours.map(
            ({ number }) => `${t('week')} ${number}`
          )
        : getLocalizedMonthNames()
    },

    yAxis: {
      min: 0,
      allowDecimals: true,
      title: {
        text: t('hours')
      }
    },

    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },

    series,

    credits: {
      enabled: false
    }
  };

  return (
    <StyledPaper>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </StyledPaper>
  );
};

export default CapacityGraph;
